import cloneDeep from 'lodash.clonedeep';
import { NetworkElementProps, NetworkTopologyStateEnum } from 'data/network-topology/network-topology.types';

const getObjectKey = (
  networkElement: NetworkElementProps,
  xcipioLocation: { latitude: number, longitude: number },
  baseMapOnxcipioNode?: boolean
): string => {
  if (baseMapOnxcipioNode) {
    return `${xcipioLocation.latitude},${xcipioLocation.longitude},${networkElement.location.latitude},${networkElement.location.longitude}`
  }
  return `${networkElement.location.latitude},${networkElement.location.longitude},${xcipioLocation.latitude},${xcipioLocation.longitude}`
}

export const adaptConnectorCollorMap = (
  networkElements: NetworkElementProps[],
  xcipioLocation: { latitude: number, longitude: number },
  baseMapOnxcipioNode?: boolean,
) => {
  return cloneDeep(networkElements)
    .filter((networkElement) => !!networkElement.location)
    .reduce((total, networkElement) => {
      const key = getObjectKey(networkElement, xcipioLocation, baseMapOnxcipioNode);
      const existingStatus = total[key];
      const networkElementStatus = networkElement.status;

      const status = existingStatus === NetworkTopologyStateEnum.FAILED
        ? existingStatus
        : networkElementStatus;

      return {
        ...total,
        [key]: status || NetworkTopologyStateEnum.ACTIVE
      }
    }, {} as { [key:string]: NetworkTopologyStateEnum });
}

export const adaptConnectorCollorMap2 = (
  networkElements: NetworkElementProps[],
  baseMapOnxcipioNode?: boolean,
) => {
  return cloneDeep(networkElements)
    .filter((networkElement) => !!networkElement.location)
    .filter((networkElement) => !!networkElement.connections)
    .flatMap((ne) => {
      if (ne.connections) {
        return Object.entries(ne.connections)
          .flatMap((c) => c[1])
          .map((connection) => {
            return { ...connection, source: ne.location };
          })
        // return Object.entries(ne.connections).map((x) => {
        //   return { ...x[1], source: ne.location };
        // })
      }
      return [];
    })
    .reduce((total, connection) => {
      const key = `${connection.source.latitude},${connection.source.longitude},${connection.destination.latitude},${connection.destination.longitude}`;
      const existingStatus = total[key];
      const networkElementStatus = connection.status;
      const status = existingStatus === NetworkTopologyStateEnum.FAILED
        ? existingStatus
        : networkElementStatus;

      return {
        ...total,
        [key]: status || NetworkTopologyStateEnum.ACTIVE
      }
    }, {} as { [key:string]: NetworkTopologyStateEnum });
}

export const getClusterStatus2 = (states: any[]) => {
  if (states.find((state) => state === NetworkTopologyStateEnum.FAILED)){
    return NetworkTopologyStateEnum.FAILED
  }

  if (states.find((state) =>
    state === NetworkTopologyStateEnum.INACTIVE ||
    state === NetworkTopologyStateEnum.BLOCKED)
  ){
    return NetworkTopologyStateEnum.INACTIVE
  }

  if (
    states.find((state) =>
        state === NetworkTopologyStateEnum.IDLE ||
        state === NetworkTopologyStateEnum.ACTIVE)
  ) {
    return NetworkTopologyStateEnum.ACTIVE;
  }

  return NetworkTopologyStateEnum.UNKNOWN;
}

export const getClusterStatus =(clusters: any[]) => {
  return clusters
    .reduce((status, actualStatus) => {
      if (status === NetworkTopologyStateEnum.FAILED) {
        return NetworkTopologyStateEnum.FAILED
      }
      return actualStatus;
    }, '');
}

export const setConnectorColor = (status: NetworkTopologyStateEnum): string => {
  if (status === NetworkTopologyStateEnum.ACTIVE) {
    return '#43A35E';
  }

  if (status === NetworkTopologyStateEnum.FAILED) {
    return '#E72525';
  }

  if (status === NetworkTopologyStateEnum.INACTIVE) {
    return '#5C7080';
  }

  return '#000000';
}
